import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCbY9iE4UyOvCrxFExFdX-zzhs3_E-5TTk",
  authDomain: "iaan-95b49.firebaseapp.com",
  projectId: "iaan-95b49",
  storageBucket: "iaan-95b49.firebasestorage.app",
  messagingSenderId: "570846920004",
  appId: "1:570846920004:web:9c1374d3fb3372c1feab11",
  measurementId: "G-F6BH5RMFRR"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
